// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__eeldM","header":"ReportDetails_header__dv133","title":"ReportDetails_title__lhBPh","left":"ReportDetails_left__2hiJM"};